import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountConfirmDialogComponent } from '../account-confirm-dialog/account-confirm-dialog.component';
import { LogindialogComponent } from '../logindialog/logindialog.component';
import { VerifyOtpDialogComponent } from '../verify-otp-dialog/verify-otp-dialog.component';
import { UserService } from '@app-services/user/user.service';
import { TermsAndConditionsDialogComponent } from '../terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { TestlistService } from '@app-services/test/testlist.service';
import { WhatsAppService } from '@app-services/whatsapp/whats-app.service';
import { SignupService } from '@app-services/signup/signup.service';
import { TenantConstant } from '@app-constants/tenant.constant';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { clearLocalStorage } from 'src/app/helpers/functions';


@Component({
  selector: 'app-signupdialog',
  templateUrl: './signupdialog.component.html',
  styleUrls: ['./signupdialog.component.css']
})
export class SignupdialogComponent implements OnInit {
  tenant : any = TenantConstant.tenant;
  signupForm!: FormGroup;
  dialogConfigData: any;
  phoneNumber: any = "";
  registrationErrorMessage: any = '';
  constructor(public signUpService: SignupService,
    private userService: UserService,
    private testListService: TestlistService,
    private whatsAppService: WhatsAppService,
    private dialog: MatDialog,
    private gaService: GAnalyticsService,
    private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SignupdialogComponent>) {
      dialogRef.disableClose = true;

  }

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
    this.dialogConfigData = this.data;

    this.createSignUpForm();

    if (this.data.phone) {
      this.phoneNumber = this.data.countryCode +' '+ this.data.phone;
      this.setSignUpForm();
    }
    this.clearLocalStorage();
  }

  clearLocalStorage(): void {
    clearLocalStorage();
  }

  createSignUpForm(): void {
    if (this.tenant=='srichaitanya') {
      this.signupForm = this._formBuilder.group({
        phone: ['', [Validators.required]],
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        admissionNumber: ['',[Validators.required]],
        whatsappConsent: [true, [Validators.required]],
        valid: false,
      })
    } else {
      this.signupForm = this._formBuilder.group({
        phone: ['', [Validators.required]],
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        whatsappConsent: [true, [Validators.required]],
        valid: false,
      })
    }

  }

  setSignUpForm(): void {
    if (this.tenant == 'srichaitanya') {
      this.signupForm = this._formBuilder.group({
        phone: [this.phoneNumber, [Validators.required]],
        firstName: [this.dialogConfigData.firstName || '', [Validators.required]],
        lastName: [this.dialogConfigData.lastName || '', [Validators.required]],
        admissionNumber: [this.dialogConfigData.admissionNumber?this.dialogConfigData.admissionNumber : '',  [Validators.required]],
        whatsappConsent: [this.dialogConfigData.whatsappConsent == undefined ? true: this.dialogConfigData.whatsappConsent, [Validators.required]],
        valid:true,
      });
    } else {
      this.signupForm = this._formBuilder.group({
        phone: [this.phoneNumber, [Validators.required]],
        firstName: [this.dialogConfigData.firstName || '', [Validators.required]],
        lastName: [this.dialogConfigData.lastName || '', [Validators.required]],
        whatsappConsent: [this.dialogConfigData.whatsappConsent == undefined ? true: this.dialogConfigData.whatsappConsent, [Validators.required]],
        valid:true,
      });
    }
  }

  get s() { return this.signupForm.controls; }

  enterKey(event : any) : void { //currently, set on lastName field
    //this.signupForm.markAllAsTouched()
    if (event.keyCode === 13) {
        this.next();
    }
  }

  checkbox(): any {
    this.signupForm.get('whatsappConsent')?.setValue(this.signupForm?.value?.whatsappConsent ? true: false)
  }

  next(): void {
    this.signupForm.markAllAsTouched()
    this.signupForm.get('phone')?.setValue(this.data.phone);
    if(this.signupForm.valid){
      // tslint:disable-next-line:max-line-length
      this.register(this.signupForm.value, this.dialogConfigData.countryCode)
    }
  }

  register(formValue: any, countryCode: string): any {
    this.signUpService.generateOtp(formValue, countryCode).subscribe((data:any) => {
      console.log(data);
      if (data) {
        this.dialogRef.close();
        this.openOTPVerificationPopup();
      } else { this.signupForm.get('phone')?.setValue(this.phoneNumber); }
    },
      (error) => {                                     // on error
        this.signupForm.get('phone')?.setValue(this.phoneNumber);
        if (error.error && error.error.message) {
          this.registrationErrorMessage = error.error.message
        } else {
          this.registrationErrorMessage ="Server error"
        }
        
        console.log(error);
      });
  }

  openOTPVerificationPopup():void {
    const formVal = this.signupForm.value; 
    const config: MatDialogConfig = {
      width: '450px',
      data: {
        message: 'Verify OTP',
        message2: `Please verify the OTP sent to ${this.dialogConfigData.countryCode} ${formVal.phone} `,
        totalData: formVal,
        countryCode: this.dialogConfigData.countryCode,
        phone: formVal.phone,
        isNormalFlow: true,
        actionData: this.data?.actionData
      },
      autoFocus: true
    };

    const dialogRef = this.dialog.open(VerifyOtpDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        this.gaService.sendEvent(
          'User Signup',
          '',
          '',
          '',
          {'event': 'User Signup' ,
          'Phone Number': this.signupForm.value.phone,
          'First Name': this.signupForm.value.firstName,
          'Last Name': this.signupForm.value.lastName,
          'City': '',
          'Email ID': '',
          'Whatsapp_consent': this.signupForm.value?.whatsappConsent,
          }
        )
        if(formVal.whatsappConsent){
          this.sendWhatsAppWelcomeMessage()
        }
        this.openAccountConfirmDialog();
      }
      if(!value && config.data.isNormalFlow) {
        this.signupCanceled()
      }
    });
  }

  sendWhatsAppWelcomeMessage(): any {
    const formVal = this.signupForm.value; 
    this.whatsAppService.sendWelcomeMessage(this.dialogConfigData.countryCode, formVal.phone,formVal.firstName,formVal.lastName).subscribe((data:any) => {
      console.log(data);
    },
      (error) => {                                     // on error
        console.log(error);
      });
  }

  // test(_headers: any): any {
  //   this.testListService.saveToken({},_headers).subscribe((data:any) => {
  //     console.log(data);
  //   },
  //     (error) => {                                     // on error
  //       console.log(error);
  //     });
  // }

  openAccountConfirmDialog() {
    const config: MatDialogConfig = {
      width: '487px',
      height: '292px',
      data: { message: 'Account Created, Congratulations!', message2: `You have successfully created an account with Infinity Learn. Happy Learning :) `, actionData: this.data?.actionData }
    };
    this.dialog.open(AccountConfirmDialogComponent, config);
  }

  keyEscape(event: any) {
    if(event.key === 'Escape') {
      this.signupCanceled();
      this.dialogRef.close();
    }

    if(event.keyCode === 13) {
      document.getElementById('RegisterAndVerify')?.focus()
    }
  }

  closeDialogue() {
    this.signupCanceled();
    this.dialogRef.close();
  }

  editMobileNumber() {
    this.dialogRef.close();
    const dialogConfigData = this.dialogConfigData;
    const config: MatDialogConfig = {
      // width: '487px',
      // height: '226px',
      data: { message: 'Hey, ready to get started?', editMobileNumber: true, phone: dialogConfigData.phone, actionData: this.data?.actionData }//deal with isdCode later
    };
    
    const dialogRef = this.dialog.open(LogindialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value && value.phone) {
          const config: MatDialogConfig = {
            width: '500px',
            data: {
                    message: `Seems like you're a new user`, 
                    message2: 'Please enter your name to register', 
                    phone: value.phone, 
                    countryCode: value.countryCode,
                    firstName: this.signupForm.value.firstName,
                    lastName: this.signupForm.value.lastName,
                    whatsappConsent: this.signupForm.value.whatsappConsent,
                    actionData: this.data?.actionData
                  }
          };
          this.dialog.open(SignupdialogComponent, config);
      }
    });
  }

  openTermsAndConditionsDialog(): void {
    const config: MatDialogConfig = {
      // width: '557px',
      width: '500px',
      height: '90vh',
      panelClass: 'terms-condition-modalbox',
      data: { message: 'Terms of Use' }
    };
    this.dialog.open(TermsAndConditionsDialogComponent, config);
  }

  signupCanceled() {
    let body = [];
    body.push({ Attribute: 'FirstName', Value: this.signupForm.value?.firstName  });
    body.push({ Attribute: 'LastName', Value: this.signupForm.value?.lastName});
    body.push({ Attribute: 'Phone', Value: this.signupForm.value?.phone });
    body.push({ Attribute: 'SearchBy', Value: 'Phone'})
    this.signUpService.leadSquaredJee(body);
  }
}
